var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7822_8343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5133 11.6113H23.6289C23.2191 11.6113 22.8293 11.8082 22.5883 12.1457L16.2722 20.9046L13.4115 16.935C13.1704 16.6015 12.7847 16.4006 12.3709 16.4006H10.4865C10.2253 16.4006 10.0726 16.6979 10.2253 16.9109L15.2316 23.8537C15.3498 24.0188 15.5058 24.1533 15.6864 24.2461C15.867 24.3389 16.0671 24.3873 16.2702 24.3873C16.4733 24.3873 16.6734 24.3389 16.854 24.2461C17.0346 24.1533 17.1905 24.0188 17.3088 23.8537L25.7704 12.1216C25.9271 11.9087 25.7744 11.6113 25.5133 11.6113Z",
    fill: "#2DA548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05982 0 0 8.05982 0 18C0 27.9402 8.05982 36 18 36C27.9402 36 36 27.9402 36 18C36 8.05982 27.9402 0 18 0ZM18 32.9464C9.74732 32.9464 3.05357 26.2527 3.05357 18C3.05357 9.74732 9.74732 3.05357 18 3.05357C26.2527 3.05357 32.9464 9.74732 32.9464 18C32.9464 26.2527 26.2527 32.9464 18 32.9464Z",
    fill: "#2DA548"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7822_8343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.4dd4e67a8c997e95032399d5490c33ea.svg";
export { ForwardRef as ReactComponent };